import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
const controller = rpcController("Colonia");
const crud = rpcCrudService<models.ColoniaDTO>(controller);

const otros = cacheResource({
    query: async (filtro: models.FiltroColonia): Promise<models.ColoniaDTO[]> => await controller("Query", {}, filtro),

    /**Obtiene información de las colonias relacionadas con un CP */
    ObtenerCodPostalInfo: async (cp: number): Promise<models.CodPostalnfo> => await controller('ObtenerCodPostalInfo', { cp }),
},
    { query: true })
export const Colonia = bindResource({ ...crud, ...otros });


// WEBPACK FOOTER //
// ./app/resources/items/colonia.ts